module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [(_vm.mostrarConfirmacionEliminar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarEliminar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionEliminar = false
      },
      "do": _vm.validarEliminar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Está seguro de guardar la fecha de nacimiento?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Eliminando...")] : [_vm._v("Eliminar")]], 2), _c('div', {
    staticClass: "info-validar-eliminar",
    attrs: {
      "slot": "information"
    },
    slot: "information"
  }, [(_vm.empleadosValidados.length > 0) ? [_c('span', [_vm._v("No se puede eliminar el cargo ya que tiene empleados asociados:")]), _c('ul', _vm._l((_vm.empleadosValidados), function(o, index) {
    return _c('li', {
      key: index
    }, [_c('span', [_vm._v(_vm._s(o.nombre))])])
  }), 0)] : _vm._e()], 2)])], 1) : _vm._e(), _c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "lista_solicitudes",
    staticClass: "box position-relative"
  }, [_c('div', {
    staticClass: "contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Empleados sin Fecha de Nacimiento")])]), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "body",
    staticClass: "body"
  }, [_c('div', {
    staticClass: "information"
  }, [(_vm.lista.length > 0) ? [_c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Empleado")]), _c('th', [_vm._v("Fecha de Nacimiento")]), _c('th', {
    staticClass: "hide-break-1"
  })]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: o + index + '',
      staticClass: "row-table"
    }, [_c('td', [_c('span', [_vm._v(_vm._s(o.nombre))])]), _c('td', [_c('div', {
      staticClass: "flex fdc"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.fechaNacimiento),
        expression: "o.fechaNacimiento"
      }],
      staticClass: "input",
      attrs: {
        "type": "date"
      },
      domProps: {
        "value": (o.fechaNacimiento)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "fechaNacimiento", $event.target.value)
        }
      }
    }), _c('div', {
      staticClass: "show-break-1 text-center mt-5"
    }, [_c('button', {
      staticClass: "button is-small is-primary",
      on: {
        "click": function($event) {
          return _vm.guardarFechaNacimiento(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-save is-small"
    })]), _c('span', [_vm._v("Guardar")])])])])]), _c('td', {
      staticClass: "text-center hide-break-1"
    }, [_c('button', {
      staticClass: "button is-small is-primary",
      on: {
        "click": function($event) {
          return _vm.guardarFechaNacimiento(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-save is-small"
    })]), _c('span', [_vm._v("Guardar")])])])])
  }), 0)], 1)] : _vm._e(), (_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _vm._e(), (_vm.lista.length === 0 && !_vm.isLoading) ? _c('div', [_c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No existen empleados sin fecha de nacimiento")])])]) : _vm._e()], 2)])])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2612fcff","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_Empleado_Sin_Nacimiento.vue
// module id = 770
// module chunks = 0